// per docs/shape-ops-block-levels.md §2.4 Exposure
// One tag per block that is set (CF-48). A block the viewer cannot lift is drawn
// in the accent, apart from its own (neutral), so "Blocked by the System
// Administrator" does not read as one more inactive row.
import { useTranslate } from '@tolgee/react';
import { MudTag } from '@egov-moldova/mud-react';
import { blockStates, type BlockState, type BlockViewer, type Blockable } from './block-status';

export interface BlockTagsProps {
  item: Blockable;
  viewer: BlockViewer;
  labels: Record<BlockState, string>;
  size?: 'sm' | 'md';
  type?: 'subtle' | 'outlined';
}

const SEMANTIC: Record<BlockState, 'success' | 'neutral' | 'accent'> = {
  active: 'success',
  inactive: 'neutral',
  blocked_by_system_admin: 'accent',
  blocked_by_registrar: 'accent',
};

export function BlockTags({ item, viewer, labels, size, type }: BlockTagsProps): JSX.Element {
  const { t } = useTranslate();
  return (
    <>
      {blockStates(item, viewer).map((state) => (
        <MudTag
          key={state}
          variant="status"
          {...(size ? { size } : {})}
          {...(type ? { type } : {})}
          semantic={SEMANTIC[state]}
          label={t(labels[state])}
        />
      ))}
    </>
  );
}

export const SITE_BLOCK_LABELS: Record<BlockState, string> = {
  active: 'sites.status.active',
  inactive: 'sites.status.inactive',
  blocked_by_system_admin: 'sites.status.blocked_by_system_admin',
  blocked_by_registrar: 'sites.status.blocked_by_registrar',
};

export const CREDENTIAL_BLOCK_LABELS: Record<BlockState, string> = {
  active: 'credentials.status.active',
  inactive: 'credentials.status.inactive',
  blocked_by_system_admin: 'credentials.status.blocked_by_system_admin',
  blocked_by_registrar: 'credentials.status.blocked_by_registrar',
};
